import styled from '@emotion/styled';
import { N200 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var Text = styled.p({
  fontSize: '11px',
  lineHeight: '14px',
  color: "var(--ds-text-subtle, ".concat(N200, ")"),
  marginTop: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var Link = styled.a({
  display: 'flex',
  alignItems: 'center',
  height: '20px',
  width: 'fit-content',
  ':hover': {
    color: "var(--ds-text-subtle, ".concat(N200, ")")
  }
});